// src/Components/LocationAddModal.jsx
import React, { useState } from 'react';
import api from '../utils/api';
import '../css/location-add-modal.css';

export default function LocationAddModal({ onClose, onSubmit, newLocation, setNewLocation }) {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (submitting) return;

    const name = newLocation.name?.trim();
    if (!name) {
      alert('이름은 필수입니다.');
      return;
    }

    setSubmitting(true);
    try {
      // 쿼리스트링으로 name과 lat/lng=0 고정 전송
      await api.post('/locations', null, {
        params: { name, lat: 0, lng: 0 },
      });

      alert('✅ 위치가 추가되었습니다.');
      onSubmit?.(); // 목록 갱신
      setNewLocation({ name: '', lat: 0, lng: 0 });
      onClose?.();
    } catch (err) {
      console.error('[ADD-LOCATION] 실패:', err);
      alert('❌ 위치 추가 실패');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="loc-modal-overlay">
      <div className="loc-modal">
        <h2 className="loc-modal__title">➕ 위치 등록</h2>

        <form className="loc-form" onSubmit={handleSubmit}>
          <input
            className="loc-input"
            type="text"
            placeholder="위치명 입력"
            value={newLocation.name || ''}
            onChange={(e) => setNewLocation((prev) => ({ ...prev, name: e.target.value }))}
          />

          {/* 좌표 UI 제거, 고정값 사용 */}
          <div className="loc-hint" style={{ margin: '8px 0', color: '#666', fontSize: 12 }}>
            좌표는 내부망 정책으로 0,0으로 저장됩니다.
          </div>

          <div className="loc-modal__buttons">
            <button className="loc-btn loc-btn--primary" type="submit" disabled={submitting}>
              {submitting ? '등록 중…' : '등록'}
            </button>
            <button className="loc-btn" type="button" onClick={onClose}>취소</button>
          </div>
        </form>
      </div>
    </div>
  );
}
